<template>
  <v-menu offset-y :close-on-content-click="false">
    <template v-slot:activator="{ on }">
      <v-btn :color="color" dark v-on="on">{{label}}</v-btn>
    </template>
    <v-color-picker
      mode="rgba"
      @input="updateSelf"
      value="#FF7417BE"
      v-model="color"
      class="mx-auto"
    ></v-color-picker>
  </v-menu>
</template>

<script>
export default {
  name: "SelectableRideTypeInput",
  model: {
    prop: "color",
    event: "input"
  },
  props: {
    color: { type: String, default: "" },
    label: { type: String, default: "" }
  },
  computed: {},
  data() {
    return {
      menu: false
    };
  },
  methods: {
    valid() {
      // console.log(this.error);

      if (this.error == null) {
        return true;
      }

      return this.error;
    },
    updateSelf(color) {
      this.$emit("input", color);
    },
    focused() {
      console.log("focused");
      this.$emit("focused");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>
